import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import styles from "./Header.module.css";
import logoImg from "../../assets/logoChopin.jpg";

import { useTranslation } from "react-i18next";


export default function Header() {
    const { t } = useTranslation();

    return (
        <header className={styles.header}>
            <Link to="/" className={styles.logo}>
                <img src={logoImg} alt="Logo" />
                <span className={styles.projTitle}>{t("header.title")}</span>
            </Link>
            <Navbar />
        </header>
    );
}